import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from "react-redux";
import type { RootState } from "@/reducers";
import type { AppDispatch } from "@/types/actions";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch = (): AppDispatch => useReduxDispatch();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
